import { DynamicLabradorComponents } from '@/components/labrador';
import { DynamicLabradorFallback } from '@/components/labrador/Fallback';
import { pascalCase } from '@/utils/index';
import ErrorBoundary from 'base/components/ErrorBoundary';
import { capitalize } from 'lodash-es';
import React from 'react';
import { Content, ContentProps } from 'types/content';

function component<T = ContentProps>(name: string) {
  const component = DynamicLabradorComponents[
    pascalCase(name) as keyof typeof DynamicLabradorComponents
  ] as React.FunctionComponent<T>;

  if (!component) {
    return DynamicLabradorFallback;
  }

  return component;
}

function renderComponent(data: Content) {
  const key = data.type.replace(/^labrador/, '');
  const Component = component(key);

  return (
    <ErrorBoundary>
      <Component {...bindProps(data)} />
    </ErrorBoundary>
  );
}

export function componentExists(name: string) {
  const component = DynamicLabradorComponents[capitalize(name) as keyof typeof DynamicLabradorComponents];

  return component !== undefined;
}

export function bindProps(contentData: Content): ContentProps {
  return {
    type: contentData.type,
    data: contentData.data,
    meta: contentData.meta,
    descendants: contentData.children,
  };
}

export function renderContentComponent(contentData: Content) {
  return renderComponent(contentData);
}

export function renderPostTypeComponent(postData: Content) {
  return renderComponent(postData);
}

export function renderBySelector(selector: string, children?: Content[]): React.JSX.Element | undefined {
  const componentData = children?.find((child) => child.meta.selector === selector);

  if (componentData) return renderComponent(componentData);
}
